const MediaCardsEN = {
  MediaCards: {
    NOT_SUPPORTED: "Your browser doesn't support HTML5 video",
    NO_THUMBNAIL: "This video doesn't yet contain a demo image.",
    SEE_MORE: 'See more',
  },
};

const MediaCardsPT = {
  MediaCards: {
    NOT_SUPPORTED: 'Seu navegador não suporta vídeo em HTML5',
    NO_THUMBNAIL: 'Este video ainda não contém uma imagem de demonstração.',
    SEE_MORE: 'Ver +',
  },
};

const MediaCardsES = {
  MediaCards: {
    NOT_SUPPORTED: 'Su navegador no es compatible con video HTML5',
    NO_THUMBNAIL: 'Este video aún no contiene una imagen de demostración.',
    SEE_MORE: 'Ver +',
  },
};

export { MediaCardsPT, MediaCardsEN, MediaCardsES };
